module.exports = __webpack_public_path__ + "img/logo.f2d7accc.png";